var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChevronLeft = function SvgChevronLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 27,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    clipPath: "url(#chevron-left_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.01,
    d: "M26.28 26.246V.702H.738v25.544z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m19.271 4.336-9.138 9.138 9.138 9.139a2.129 2.129 0 0 1-3.01 3.01L5.618 14.978a2.13 2.13 0 0 1 0-3.01L16.26 1.326a2.128 2.128 0 1 1 3.01 3.01"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "chevron-left_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M26.28 26.246V.702H.738v25.544z"
  })))));
};
export { SvgChevronLeft as ReactComponent };